/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Event_Index_HeaderInputs */



/**
* | output |
* | --- |
* | "Event Index" |
*
* @param {Compare_Event_Groups_Csv_Event_Index_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_event_index_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Event_Index_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Event_Index_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Index de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisindex")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indice degli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Индекс событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Índice de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件索引")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントインデックス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना सूचकांक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Índice de eventos")
	return /** @type {LocalizedString} */ ("Event Index")
});